import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getValidSession, clearSession } from "../helpers/sessionUtils";
import useFrontendNavigationPages from "../../components/common/useFrontendNavigationPages";
import "./HeaderNav.css";

function Header({ rightAction = null }) {
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "";
  const isMobileScreen = typeof window !== 'undefined' && window.innerWidth < 1200;

  const [isMobileNavOpen, setIsMobileNavOpen] = useState(() => isHomePage && isMobileScreen);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigationPages = useFrontendNavigationPages();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname === "") {
      if (typeof window !== 'undefined' && window.innerWidth < 1200) {
        setIsMobileNavOpen(true);
      }
    } else {
      setIsMobileNavOpen(false);
    }
  }, [location.pathname]);

  const toggleMobileNav = () => {
    setIsMobileNavOpen(!isMobileNavOpen);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // const logoUrl = "https://www.itarsia.com/img/logo.png";
  const logoUrl = "/logo-mangoloops.png";
  const myAccountIconUrl = "/assets/img/my-account.png";
  const dashboardIconUrl = "/assets/img/sidebar/dashboard.png";
  const leadsIconUrl = "/assets/img/sidebar/leads.png";
  const privacyPolicyIconUrl = "/assets/img/sidebar/privacy-policy.png";
  const feedbackIconUrl = "/assets/img/sidebar/feedback.png";
  const helpIconUrl = "/assets/img/sidebar/help.png";
  const logoutIconUrl = "/assets/img/sidebar/logout.png";

  const [currentUser, setCurrentUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const syncFromStorage = () => {
      const userSession = getValidSession();

      let resolvedUser = null;
      if (userSession?.user) {
       
        resolvedUser = userSession.user?.user || userSession.user || null;
      }

      if (!resolvedUser) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const parsed = JSON.parse(userInfoStr);
            resolvedUser = parsed?.user?.user || parsed?.user || parsed || null;
          } catch {
            resolvedUser = null;
          }
        }
      }

      if (!resolvedUser) {
        const visitorUserStr = localStorage.getItem('visitorUser');
        if (visitorUserStr) {
          try {
            const parsed = JSON.parse(visitorUserStr);
            resolvedUser = parsed?.user?.user || parsed?.user || parsed || null;
          } catch {
            resolvedUser = null;
          }
        }
      }

      setCurrentUser(resolvedUser);

      if (resolvedUser?.token && !localStorage.getItem('authToken')) {
        localStorage.setItem('authToken', resolvedUser.token);
      }
      if (resolvedUser?.token && !localStorage.getItem('token')) {
        localStorage.setItem('token', resolvedUser.token);
      }
    };

    syncFromStorage();

    const handleStorageChange = () => {
      syncFromStorage();
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);


  const handleLogout = () => {
    clearSession();
    localStorage.removeItem('userInfo');
    localStorage.removeItem('visitorUser');
    setCurrentUser(null);
    setIsSidebarOpen(false);
    navigate("/");
  };

  const showVendorSpecificOptions =
    currentUser && (currentUser.accountType === 'vendor' || currentUser.isVendor === true);
  const displayName = currentUser ? currentUser.name : "User Name";
  const userRole = currentUser ? currentUser.role_id : "user Id";

  return (
    <div>
      <header
        id="header"
        className="u-header u-header--dark-nav-links-xl u-header--show-hide-xl u-header--static-xl"
        data-header-fix-moment="500"
        data-header-fix-effect="slide"
      >
        <div className="u-header__section u-header__shadow-on-show-hide py-4 py-xl-0">
          <div
            id="logoAndNav"
            className="container-fluid py-xl-2 border-bottom-xl"
          >
            <nav className="js-mega-menu navbar navbar-expand-xl u-header__navbar u-header__navbar--no-space">
              <button
                type="button"
                className="navbar-toggler btn u-hamburger u-hamburger--primary pt-4 hamburger-pl-0 ml-3"
                aria-label="Toggle navigation"
                aria-expanded={isMobileNavOpen}
                aria-controls="navBar"
                onClick={toggleMobileNav}
              >
                <span id="hamburgerTrigger" className="u-hamburger__box">
                  <span className="u-hamburger__inner"></span>
                </span>
              </button>

              <Link
                to="/"
                className="navbar-brand u-header__navbar-brand-default u-header__navbar-brand-center u-header__navbar-brand-text-dark-xl"
                aria-label="MyTour"
              >
                <img
                  className="navbar-brand-img"
                  src={logoUrl}
                  alt="Mangoloops Logo"
                />
              </Link>

              {rightAction ? (
                <div className="ml-auto third" style={{ order: 3 }}>
                  {rightAction}
                </div>
              ) : (
                <button
                  type="button"
                  className="p-0 ml-auto third my-account-btn"
                  onClick={() => {
                    if (currentUser) {
                      toggleSidebar();
                    } else {
                      navigate("/login");
                    }
                  }}
                  aria-label="Toggle user menu"
                  style={{ width: "auto", border: "none", background: "transparent", order: 3 }}
                >
                  <div className="d-flex align-items-center" style={{ gap: '6px', margin: '0 10px', cursor: 'pointer' }}>
                    {currentUser && currentUser.profileImageUrl ? (
                      <img
                        src={currentUser.profileImageUrl}
                        alt="my-account"
                        style={{ width: "28px", height: "28px", borderRadius: "50%", objectFit: "cover" }}
                      />
                    ) : (
                      <>
                        <i className="flaticon-user" style={{ fontSize: '20px', color: '#205aa3' }}></i>
                        {!currentUser && (
                          <span className="d-inline-block" style={{ fontWeight: '600', color: '#205aa3', fontSize: '13px', whiteSpace: 'nowrap' }}>Signup</span>
                        )}
                      </>
                    )}
                  </div>
                </button>
              )}

              {/* Sidebar START */}
              <div className={`side-bar ${isSidebarOpen ? "active" : ""}`}>
                <header className="sidebar-top-header">
                  <div
                    className="close-btn"
                    onClick={toggleSidebar}
                    role="button"
                    tabIndex="0"
                    aria-label="Close user menu"
                  >
                    <i className="fas fa-times"></i>
                  </div>
                </header>

                {/* Profile Header Section */}
                {currentUser && (
                  <div
                    className="profile-header"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      if (userRole === 2) {
                        setIsSidebarOpen(false);
                        navigate("/admin/kyc", { state: { user: currentUser } });
                      }
                    }}
                  >
                    <div className="profile-img-container">
                      {currentUser.profileImageUrl ? (
                        <img
                          className="sidebar-profile-img profile-img"
                          src={currentUser.profileImageUrl}
                          alt="Profile Picture"
                        />
                      ) : (
                        <div className="profile-avatar-placeholder">
                          <i className="far fa-user"></i>
                        </div>
                      )}
                    </div>
                    <div className="profile-header-info">
                      <h4 className="profile-header-h4">{displayName}</h4>
                      {userRole === 2 ? (
                        <Link
                          to="/admin"
                          state={{ user: currentUser }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setIsSidebarOpen(false);
                          }}
                          className="view-profile-badge"
                        >
                          <span>Click to view profile</span>
                          <i className="fas fa-arrow-right"></i>
                        </Link>
                      ) : null}
                    </div>
                  </div>
                )}

                {/* Menu Items */}
                <div className={`menu ${showVendorSpecificOptions ? "border-bottom-sidebar" : ""}`}>
                  {userRole === 2 && (
                    <div className="item">
                      <Link
                        to="/admin/dashboard"
                        state={{ user: currentUser }}
                        onClick={() => setIsSidebarOpen(false)}
                        className="sidebar-menu-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="item-icon-box blue">
                          <i className="fas fa-chart-line"></i>
                        </div>
                        <span className="item-title">Dashboard</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}

                  {userRole === 2 && (
                    <div className="item">
                      <Link 
                        to="/admin/my-leads" 
                        onClick={() => setIsSidebarOpen(false)}
                        className="sidebar-menu-link"
                      >
                        <div className="item-icon-box green">
                          <i className="fas fa-users"></i>
                        </div>
                        <span className="item-title">My Leads</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}

                  {userRole === 2 && (
                    <div className="item">
                      <Link 
                        to="/admin/suggested-customers" 
                        onClick={() => setIsSidebarOpen(false)}
                        className="sidebar-menu-link"
                      >
                        <div className="item-icon-box orange">
                          <i className="fas fa-lightbulb"></i>
                        </div>
                        <span className="item-title">Suggested Leads</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}

                  {currentUser && (userRole === 3 || userRole !== 2) && (
                    <div className="item">
                      <Link 
                        to="/my-enquiries" 
                        onClick={() => setIsSidebarOpen(false)}
                        className="sidebar-menu-link"
                      >
                        <div className="item-icon-box green">
                          <i className="fas fa-list-alt"></i>
                        </div>
                        <span className="item-title">My Enquiries</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}

                  <div className="item">
                    <Link 
                      to="/page/customer-support" 
                      onClick={() => setIsSidebarOpen(false)}
                      className="sidebar-menu-link"
                    >
                      <div className="item-icon-box purple">
                        <i className="fas fa-headset"></i>
                      </div>
                      <span className="item-title">Customer Support</span>
                      <i className="fas fa-chevron-right item-arrow"></i>
                    </Link>
                  </div>

                  {currentUser && (
                    <div className="item">
                      <Link 
                        to="/page/privacy-policy" 
                        onClick={() => setIsSidebarOpen(false)}
                        className="sidebar-menu-link"
                      >
                        <div className="item-icon-box teal">
                          <i className="fas fa-user-shield"></i>
                        </div>
                        <span className="item-title">Privacy Policy</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}

                  {currentUser && (
                    <div className="item logout-item">
                      <Link 
                        onClick={handleLogout} 
                        className="sidebar-menu-link logout"
                        style={{ cursor: "pointer" }}
                      >
                        <div className="item-icon-box red">
                          <i className="fas fa-sign-out-alt"></i>
                        </div>
                        <span className="item-title">Logout</span>
                        <i className="fas fa-chevron-right item-arrow"></i>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
              {/* Sidebar END */}

              {isSidebarOpen && (
                <div
                  className="sidebar-overlay active"
                  onClick={toggleSidebar}
                ></div>
              )}

              <div
                id="navBar"
                className={`navbar-collapse u-header__navbar-collapse collapse order-xl-0 pt-4 p-xl-0 position-relative ${isMobileNavOpen ? "show" : ""
                  }`}
              >
                <ul className="navbar-nav u-header__navbar-nav">
                  {navigationPages.map((page) => (
                    <li className={`nav-item u-header__nav-item ${page.page_key === 'hotels' ? 'hotels mainMenu' : ''}`} key={page.page_key}>
                      <Link
                        to={page.slug}
                        className="menu-sec nav-link"
                        onClick={() => setIsMobileNavOpen(false)}
                      >
                        <span className={`meuicowidth ${page.iconClass}`}></span>
                        <span className="menu-title-span">{page.title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
